export default __webpack_public_path__ + "static/media/times-solid-grey.72308031.svg";